  <template>
    <div>
      <div class="projects-list">
        <div class="project-box project-hover" style="cursor: pointer" v-for="current in dataTabla.results"
          v-bind:key="current.id" @click="rowClick(current)">
          <div class="project-head" style="background-color: #e3edf3;">
            <div class="project-title">
              <h6>
                <span class="font-weight-bold">{{
                  current.tienda_obj.nombre
                }}</span>
                <br>
                #{{ current.numero }}
              </h6>
              <div v-if="current.estado == '9'" class="badge badge-danger">
                Anulado
              </div>
              <div v-else-if="!current.fecha_finalizacion" class="badge badge-success">
                En Proceso
              </div>
              <div v-else class="badge badge-dark">
                Finalizado
              </div>
              <div v-if="current.total_productos != null" class="mt-2" style="color: #384d7d">
                <strong>{{ current.total_productos }}</strong>
                {{ current.total_productos == 1 ? 'producto' : 'productos' }}
              </div>
            </div>
          </div>
          <div class="project-info">
            <div class="row align-items-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-6">
                    <div class="el-tablo highlight text-center">
                      <div class="label">Usuario</div>
                      <div>
                        <strong>
                          <p class="text-center" style="color: #384d7d">
                            {{ current.usuario.name }}
                          </p>
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="el-tablo highlight text-center">
                      <div class="label">Tipo Conteo</div>
                      <div>
                        <strong>
                          <p class="text-center" style="color: #384d7d">
                            {{ getTipoTexto(current.tipo) }}
                          </p>
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="el-tablo highlight text-center">
                      <div class="label">Inicio Conteo</div>
                      <div>
                        <strong>
                          <p class="text-center" style="color: #384d7d">
                            {{ current.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss") }}
                          </p>
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="el-tablo highlight text-center">
                      <div class="label">Fin Conteo</div>
                      <div>
                        <strong>
                          <p class="text-center" style="color: #384d7d">
                            {{ current.fecha_finalizacion | moment("DD/MM/YYYY HH:mm:ss") }}
                          </p>
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    ProductoSelectComponentV2,
  },
  props: ["dataTabla"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      posiciones: [],
      searchtext: "",
      filtro_estado: "",
      currentDet: "",
      current: {
        producto: "",
        cantidad: 0,
        posicion: "",
      },
    };
  },
  computed: {},
  mounted() { },
  methods: {
    rowClick(detalle) {
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-conteo-editar",
          params: { id: detalle.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: "inventario-conteo-editar",
          params: { id: detalle.id },
        });
      }
    },
    getTipoTexto(tipo) {
      const tipos = {
        N: 'NORMAL',
        A: 'AGRUPADO',
        B: 'ABC',
        P: 'PRÓXIMOS A VENCER',
        R: 'REVISIÓN 80/20'
      };
      return tipos[tipo] || ' - ';
    },
  },
};
</script>
